import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import "./ServiceHeadPayers.css";

const ServicesHeadPayers = () => {
  return (
    <div fluid className="services-head-container">
      <Row className="services-head-row">
        <Col
          lg={6}
          md={12}
          className="services-head-text leftheaderinservicespage"
        >
          <h6 className="services-head-subtitle">Who we serve</h6>
          <h2 className="services-head-title" style={{ color: "white" }}>
            Our expertise spans a broad continuum of healthcare organizations
            including
          </h2>
          <div className="services-head-table-container">
            <table style={{ width: "100%", borderCollapse: "collapse" }}>
              <tbody>
                <tr>
                  <td
                    style={{
                      border: "none",
                      padding: "8px",
                      fontFamily: "Helvetica",
                    }}
                  >
                    Health Plans / Payers
                  </td>
                  <td
                    style={{
                      border: "none",
                      padding: "8px",
                      fontFamily: "Helvetica",
                    }}
                  >
                    TPAs (Third-Party Administrators)
                  </td>
                </tr>
                <tr>
                  <td
                    style={{
                      border: "none",
                      padding: "8px",
                      fontFamily: "Helvetica",
                    }}
                  >
                    Healthcare Providers & Systems
                  </td>
                  <td
                    style={{
                      border: "none",
                      padding: "8px",
                      fontFamily: "Helvetica",
                    }}
                  >
                    Government Agencies / Contractors
                  </td>
                </tr>
                <tr>
                  <td
                    style={{
                      border: "none",
                      padding: "8px",
                      fontFamily: "Helvetica",
                    }}
                  >
                    MSOs / ACOs
                  </td>
                  <td
                    style={{
                      border: "none",
                      padding: "8px",
                      fontFamily: "Helvetica",
                    }}
                  >
                    EDI Clearinghouses & Health Tech
                  </td>
                </tr>
                <tr>
                  <td
                    style={{
                      border: "none",
                      padding: "8px",
                      fontFamily: "Helvetica",
                    }}
                  >
                    PBMs & Behavioural Health Orgs
                  </td>
                  <td
                    style={{
                      border: "none",
                      padding: "8px",
                      fontFamily: "Helvetica",
                    }}
                  >
                    HealthTech Startups
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </Col>

        <Col lg={6} md={12} className="services-head-text">
          <h6 className="services-head-subtitle">What we serve</h6>
          <h2 className="services-head-title" style={{ color: "white" }}>
            Our commitment is to deliver excellence with every Service we offer.
          </h2>
          <div className="services-head-table-container">
            <table style={{ width: "100%", borderCollapse: "collapse" }}>
              <tbody>
                <tr>
                  <td
                    style={{
                      border: "none",
                      padding: "8px",
                      fontFamily: "Helvetica",
                    }}
                  >
                    Claims Processing & Adjudication
                  </td>
                  <td
                    style={{
                      border: "none",
                      padding: "8px",
                      fontFamily: "Helvetica",
                    }}
                  >
                    Enrolment & Eligibility
                  </td>
                </tr>
                <tr>
                  <td
                    style={{
                      border: "none",
                      padding: "8px",
                      fontFamily: "Helvetica",
                    }}
                  >
                    EDI Clearinghouse & File Management
                  </td>
                  <td
                    style={{
                      border: "none",
                      padding: "8px",
                      fontFamily: "Helvetica",
                    }}
                  >
                    Utilization Management (UM) & Prior Authorization Support
                  </td>
                </tr>
                <tr>
                  <td
                    style={{
                      border: "none",
                      padding: "8px",
                      fontFamily: "Helvetica",
                    }}
                  >
                    Appeals & Grievances Processing
                  </td>
                  <td
                    style={{
                      border: "none",
                      padding: "8px",
                      fontFamily: "Helvetica",
                    }}
                  >
                    Call Center Operations
                  </td>
                </tr>
                <tr>
                  <td
                    style={{
                      border: "none",
                      padding: "8px",
                      fontFamily: "Helvetica",
                    }}
                  >
                    Credentialing & Provider Data Management
                  </td>
                  <td
                    style={{
                      border: "none",
                      padding: "8px",
                      fontFamily: "Helvetica",
                    }}
                  >
                    Premium Billing & Finance Support
                  </td>
                </tr>
                <tr>
                  <td
                    style={{
                      border: "none",
                      padding: "8px",
                      fontFamily: "Helvetica",
                    }}
                  >
                    Reporting & Analytics (Non-core)
                  </td>
                  <td
                    style={{
                      border: "none",
                      padding: "8px",
                      fontFamily: "Helvetica",
                    }}
                  >
                    Mailroom & Fulfilment Services
                  </td>
                </tr>
                <tr>
                  <td
                    style={{
                      border: "none",
                      padding: "8px",
                      fontFamily: "Helvetica",
                    }}
                  >
                    Technical Help Desk & Application Support
                  </td>
                  <td
                    style={{
                      border: "none",
                      padding: "8px",
                      fontFamily: "Helvetica",
                    }}
                  >
                    Encounter Data Management
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default ServicesHeadPayers;
